export function getIconUrl({ iconId }) {
  if (iconId == null) return null;

  return `https://icons-cdn.athom.com/${iconId}.svg`;
}
